// CoachingInsight.Lookup_KpiType
export enum KpiType {
    COACHING_CAPACITY = 1,
    COACHING_COVERAGE,
    OPPORTUNITY_ALIGNMENT,
    COACHING_PROCESS_COMPLIANCE,
    COACHED_IMPROVEMENT,
    MANAGEMENT_IMPROVEMENT_INDEX,
    FRONT_LINE_OA,
    WINNING_PERCENTAGE,
    FL_MANAGEMENT_IMPROVEMENT_INDEX,

    /** @deprecated */
    FL_WINNING_PERCENTAGE,
}
